import { AxiosInstance } from 'axios';
import { ITagGroup } from 'src/views/Admin/TagGroups/types';
import { insertId } from '../../insertId';
import { toResponse } from '../../genericToResponse';

export default (api: AxiosInstance, url: string) => async (
  tagGroup: ITagGroup
) => {
  const urlWithId = insertId(url, tagGroup.id);
  const response = await api.put(urlWithId, tagGroup);
  return toResponse(response.data) as ITagGroup;
};



// WEBPACK FOOTER //
// ./src/services/api/admin/tagGroups/update.ts